<template>
  <div id="sskInfoFillingPage">
    <div class="headline">填写参保信息</div>
    <div>
      <div class="punctuation">
        <span ></span>
        <span >被保险人信息</span>
      </div>
      <ul class="beInsureWrap">
        <li class="relaWrap" hidden>
          <div class="tit fl">关系：</div>
          <div class="sInfo">
            <input type="text" placeholder="其他"  disabled="disabled" v-model="relationship" />
          </div>
        </li>
        <li>
          <div class="tit">姓名：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入被保险人姓名" v-model="insuredName"/>
          </div>
        </li>
        <li>
          <div class="tit">证件类型：</div>
          <div class="sInfo select">
            <div @click="cardPopupState = true">{{abbreviation ? abbreviation : '请选择'}}</div>
          </div>
          <!--<mt-popup v-model="cardPopupState" position="bottom" v-if="cardPopupState" class="cardPopupState" >
            <mt-picker :slots="slots" @change="selectInsureCardType" value-key="label" ref="picker" showToolbar class="cardTypeList">
              <div class="picker-toolbar-title">
                <div class="confirm" @click="confirmInsureCardType">确定</div>
              </div>
            </mt-picker>
          </mt-popup>-->
          <van-popup v-model="cardPopupState" v-if="cardPopupState" position="bottom" class="cardPopupState">
            <van-picker
              show-toolbar
              :columns="columns"
              @cancel="cardPopupState = false"
              @confirm="confirmInsureCardType"
            />
          </van-popup>
        </li>
        <li>
          <div class="tit">证件号码：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入被保险人证件号码" v-model="insuredIdCard" maxlength="20" onKeyUp="value=value.replace(/[\W]/g,'')" />
          </div>
        </li>
        <li>
          <div class="tit">手机号：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入手机号" v-model="insuredMobile" maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')" disabled="disabled" />
          </div>
        </li>
        <li v-if="cardState">
          <div class="tit">出生日期：</div>
          <div class="sInfo">
            <div class="block">
              <el-date-picker
                v-model="brithday"
                type="date"
                align="center"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                class="my-el-date-picker-add">
              </el-date-picker>
            </div>
          </div>
        </li>
        <li v-if="cardState">
          <div class="tit">性别：</div>
          <div class="sInfo">
            <el-radio v-model="sex" label="M">男</el-radio>
            <el-radio v-model="sex" label="F">女</el-radio>
          </div>
        </li>
      </ul>
    </div>

    <footer>
      <div class="footerUnit">
        <a class="kefu" href="https://work.weixin.qq.com/kfid/kfce82ed2eaaae38c7f">
          <div class="kefu">
            <div class="kefuImg"></div>
            <div class="kefuText">客服</div>
          </div>
        </a>
        <div class="submit" @click="submitOrder">提交</div>
      </div>
    </footer>

    <!-- 身份核验通知弹窗 -->
    <el-dialog
      :visible.sync="validationIdentityDialog"
      width="84%"
      :modal="true"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :show-close="false"
      class="validationIdentityDialog"
      center>
      <div class="validationIdentityView">
        <div class="head">
          <img class="head-img" src="../../../../static/images/product/ssk/confirmPopupHeader.png" alt="" >
          <div class="head-title">身份核验通知</div>
        </div>
        <div class="check">
          <div class="validationContent">
            <div>尊敬的客户，请核实您属于以下列示的人群，才可以继续办理投保：</div>
            <div>1、本市社会医疗保险参保人员及本市其他医疗保障人员（含省、市、区分级管理的医疗保障人员，本市行政区域内单位自行管理的医疗保障人员）；</div>
            <div>2、本市户籍人员；</div>
            <div>3、截至2022年12月31日，在本市办理并持有《广东省居住证》且连续居住登记时间满1年的人员；</div>
            <div>4、经本市有关部门认定在本市行政区域内见义勇为的人员；</div>
            <div>5、在本市南沙区就业、居住和就读的香港、澳门居民。</div>
            <div>6、入选国家、省、市各类各级人才计划的本市高层次人才，以及持有广东省人才优粤卡和广州市人才绿卡的本市各类人才。</div>
            <div>
              <b style="font-size: 1.5rem; color: #333333"> 如不符合上述“穗岁康”投保条件，请勿继续投保，否则将无法获得“穗岁康”理赔保障。 </b>
            </div>
            <div class="check-readPromise flex-start">
              <span class="check_box whetherAgree" @click="agreePromise">
                <img class="checkbox" src="../../../../static/images/product/ssk/checkbox_no.png" v-if="checked == false">
                <img class="checkbox" src="../../../../static/images/product/ssk/checkbox_yes.png" v-if="checked == true">
              </span>
              <span class="readPromise" @click="readPromise" >本人承诺书</span>
            </div>
          </div>
        </div>
        <div class="dialogFooter space-between">
          <div @click="validationIdentityDialog = false">取消</div>
          <div @click="checkConfirm()">确认</div>
        </div>
      </div>
    </el-dialog>

    <!-- 本人承诺书弹窗 -->
    <el-dialog
      :visible.sync="readPromiseDialog"
      width="100%"
      :modal="true"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :show-close="false"
      class="readPromiseDialog"
      center>
      <div class="readPromiseView">
        <div class="head">
          <div>您需要阅读以下内容</div>
        </div>
        <div class="readPromiseContent">
          本人承诺：本人<span>{{insuredName}}</span>已知悉“穗岁康”投保身份要求，本次投保的被保险人均符合“穗岁康”投保身份要求，属于前述的广州市其他医疗保障人员、广州市户籍人员、
          截至2022年12月31日在广州市办理并持有《广东省居住证》且连续居住登记时间满1年的人员、经广州有关部门认定在本市行政区域内的见义勇为人员或在本市南沙区就业、居住和就读的香港、澳门居民。
          如投保身份不符合要求，将无法获得“穗岁康”理赔保障，由此导致的经济损失和法律责任由本人承担。
        </div>
        <div class="dialogFooter">
          <div @click="readAndAgree">已阅读，并同意上述内容</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "sskInfoFillingPage",
    data() {
      return {
        skuList: [],
        rightsToken: '',
        eventLogToken: '',
        saleToken: 'kr7CfMZLMHY+gOi+v8ypnA==',
        skuId: '',
        phoneType: '',
        slots: [
          {
            values: [
              {label: '居民身份证(户口薄)', value: '1', abbreviation: '身份证'},
              {label: '中国人民解放军军官证', value: '2', abbreviation: '军官证'},
              {label: '中国人民武装警察警官证', value: '14', abbreviation: '警察证'},
              {label: '香港特区护照/港澳居民来往内地通行证', value: '15', abbreviation: '香港护照'},
              {label: '澳门特区护照/港澳居民来往内地通行证', value: '16', abbreviation: '澳门护照'},
              {label: '台湾居民来往大陆通行证', value: '5', abbreviation: '台湾通行证'},
              {label: '外国人永久居留证', value: '17', abbreviation: '外国人永久居留证'},
              {label: '外国人护照', value: '10', abbreviation: '外国人护照'},
              {label: '残疾人证', value: '18', abbreviation: '残疾人证'},
              {label: '军列属证明', value: '19', abbreviation: '军列属证明'},
              {label: '外国人就业证', value: '20', abbreviation: '外国人就业证'},
              {label: '外国专家证', value: '21', abbreviation: '外国专家证'},
              {label: '外国人常驻记着证', value: '22', abbreviation: '外国人常驻记着证'},
              {label: '台港澳人员就业证', value: '23', abbreviation: '台港澳人员就业证'},
              {label: '回大陆(内地)定居专家证', value: '24', abbreviation: '回大陆定居专家证'},
              /*{label: '港澳台居民居住证', value: '25', abbreviation: '港澳台居民居住证'},
              {label: '社会保障卡', value: '26', abbreviation: '社会保障卡'},
              {label: '其他身份证件', value: '27', abbreviation: '其他身份证件'},*/
            ],
            className: 'cardTypeList',
          },
        ],
        insureCardTypeList: [
          {label: '居民身份证(户口薄)', value: '1', abbreviation: '身份证'},
          {label: '中国人民解放军军官证', value: '2', abbreviation: '军官证'},
          {label: '中国人民武装警察警官证', value: '14', abbreviation: '警察证'},
          {label: '香港特区护照/港澳居民来往内地通行证', value: '15', abbreviation: '香港护照'},
          {label: '澳门特区护照/港澳居民来往内地通行证', value: '16', abbreviation: '澳门护照'},
          {label: '台湾居民来往大陆通行证', value: '5', abbreviation: '台湾通行证'},
          {label: '外国人永久居留证', value: '17', abbreviation: '外国人永久居留证'},
          {label: '外国人护照', value: '10', abbreviation: '外国人护照'},
          {label: '残疾人证', value: '18', abbreviation: '残疾人证'},
          {label: '军列属证明', value: '19', abbreviation: '军列属证明'},
          {label: '外国人就业证', value: '20', abbreviation: '外国人就业证'},
          {label: '外国专家证', value: '21', abbreviation: '外国专家证'},
          {label: '外国人常驻记着证', value: '22', abbreviation: '外国人常驻记着证'},
          {label: '台港澳人员就业证', value: '23', abbreviation: '台港澳人员就业证'},
          {label: '回大陆(内地)定居专家证', value: '24', abbreviation: '回大陆定居专家证'},
          {label: '港澳台居民居住证', value: '25', abbreviation: '港澳台居民居住证'},
          {label: '社会保障卡', value: '26', abbreviation: '社会保障卡'},
          {label: '其他身份证件', value: '27', abbreviation: '其他身份证件'},
        ],
        columns: [
          '居民身份证(户口薄)',
          '中国人民解放军军官证',
          '中国人民武装警察警官证',
          '香港特区护照/港澳居民来往内地通行证',
          '澳门特区护照/港澳居民来往内地通行证',
          '台湾居民来往大陆通行证',
          '外国人永久居留证',
          '外国人护照',
          '残疾人证',
          '军列属证明',
          '外国人就业证',
          '外国专家证',
          '外国人常驻记着证',
          '台港澳人员就业证',
          '回大陆(内地)定居专家证',
          '港澳台居民居住证',
          '社会保障卡',
          '其他身份证件',
        ],
        cardPopupState: false,
        cardState: false,
        //-- 受益人信息
        cardType: '1',
        insureCardType: '',
        abbreviation: '',
        relationship: '其它',
        insuredName: '',
        insuredIdCard: '',
        insuredMobile: '',
        brithday: '',
        sex: 'M',
        //-- 权益数据
        cpPhoneMoney: '',
        //-- 身份核验通知弹窗
        validationIdentityDialog: false,
        checked: false,
        //-- 本人承诺书弹窗
        readPromiseDialog: false,
      }
    },
    methods: {
      // 是否同意 -> 本人承诺书
      agreePromise(){
        let that = this;
        that.checked = that.checked ? false : true;
      },
      // 查看 -> 本人承诺书
      readPromise(){
        this.readPromiseDialog = true;
      },
      // 确认阅读（勾选） -> 本人承诺书
      checkConfirm(){
        let that = this;
        if (that.checked){
          that.validationIdentityDialog = false;
          that.submitOrder();
        }else {
          that.$message.error("请阅读本人承诺书！");
        }
      },
      // 阅读并同意 -> 本人承诺书
      readAndAgree(){
        this.readPromiseDialog = false;
        this.checked = true;
      },
      // 选择证件类型
      selectInsureCardType(picker, values){
        let that = this,
          {abbreviation, label, value} = values[0];

        that.cardType = value;
        that.insureCardType = label;
        that.abbreviation = abbreviation;
      },
      // 确认证件类型
      confirmInsureCardType(values){
        let that = this,
          {insureCardTypeList} = that;

        for (let i in insureCardTypeList){
          const {abbreviation, label, value} = insureCardTypeList[i];

          if (values == label){
            that.cardType = value;
            that.insureCardType = label;
            that.abbreviation = abbreviation;
          }
        }

        this.cardPopupState = false;
      },
      //-- 获取权益数据
      getRightsInfo(){
        let that = this;
        let loading = that.Loading.service({fullscreen: true});
        that.axios.post('/management/unicom/getRightsInfo', {rightsToken: that.rightsToken}).then((response) => {
          that.$nextTick(() => loading.close());
          let data = response.data;

          if (data.success) {
            const {cpPhoneMoney, phoneNum, skuList} = data.datas;
            that.skuList = skuList;
            that.cpPhoneMoney = cpPhoneMoney;
            that.insuredMobile = phoneNum;
          }else {
            that.$$.alert({
              message: data.msg,
              type: data.msg == '权益已领取!' ? "success":"info",
              onOk: function () {
                that.$router.go(-1);
              }
            });

            if (data.msg == '权益已领取!'){
              localStorage.removeItem('interests_rightsToken'+that.saleToken);
              localStorage.removeItem('interests_loginAccount'+that.saleToken);
              localStorage.removeItem('interests_router'+that.saleToken);
              localStorage.removeItem('interests_eventLogToken'+that.saleToken);
            }
          }
        });
      },
      //-- 领取权益
      submitOrder(){
        let that = this,
          {rightsToken, insuredName, insuredIdCard, insuredMobile, cardType, brithday, sex} = that;

        //-- 校验
        const errorMsg = that.validationForm();
        if(that.$$.isValidObj(errorMsg)) return that.$message.error(errorMsg);

        if (!that.checked) return that.validationIdentity();

        brithday = brithday.replace(/-/g,'');

        // 其他信息
        let extendJson = {};

        // 受益人信息
        let insuredList = [{
          insuredName,
          insuredIdCard,
          insuredMobile,
          cardType,
        }];

        if (cardType != 1){
          insuredList[0]["brithday"] = brithday;
          insuredList[0]["sex"] = sex;
        }

        let params = {
          "rightsToken": rightsToken,
          "extendJson": JSON.stringify(extendJson),
          "insuredList": JSON.stringify(insuredList),
          "skuId": that.skuId,
          "eventLogToken": that.eventLogToken
        };

        // console.log(params);
        // return;

        let loading = that.Loading.service({fullscreen: true});
        that.axios.post('/management/unicom/submitOrder', params).then((response) => {
          that.$nextTick(() => loading.close());
          let data = response.data;

          if (data.success) {
            this.$$.alert({
              message: "参保申请已登记，核保结果短信通知，敬请留意。",
              type: "success",
              onOk: function () {
                // console.log(data);
                localStorage.removeItem('interests_rightsToken'+that.saleToken);
                localStorage.removeItem('interests_loginAccount'+that.saleToken);
                localStorage.removeItem('interests_router'+that.saleToken);
                localStorage.removeItem('interests_eventLogToken'+that.saleToken);

                that.$router.go(-1);
              }
            });
          }else {
            that.errorPrompt = data.msg;
          }
        });
      },
      //-- 校验
      validationForm(){
        let that = this;
        const {insuredName, insuredIdCard, insuredMobile, cardType, insureCardType, brithday} = that;

        // 获取SkuId
        for (let i in that.skuList){
          let unit = that.skuList[i];

          that.skuId = unit['skuId'];
        }

        if(!that.$$.isValidObj(insuredName)) return "请输入姓名~";
        if (that.$$.constant.nameReg.test(insuredName) === false) return "姓名不正确!";

        if (cardType == 1){
          if(!that.$$.isValidObj(insuredIdCard)) return "请输入身份证号~";
          if (that.$$.constant.beInsureIdTypeOneReg.test(insuredIdCard) === false) return "身份证格式不正确!";
        }else {
          if(!that.$$.isValidObj(insuredIdCard)) return `请输入${insureCardType}~`;
        }

        // if(!that.$$.isValidObj(insuredMobile)) return "请输入手机号~";
        // if (that.$$.constant.phoneReg.test(insuredMobile) === false) return "手机号格式不正确!";

        if(cardType != 1 && !that.$$.isValidObj(brithday)) return "请选择出生日期~";
      },

      // 身份核验通知
      validationIdentity(){
        let that = this;

        that.validationIdentityDialog = true;
      }
    },
    mounted() {
      let that = this;

      that.rightsToken = that.$route.query.rightsToken;

      //-- 获取权益数据
      if (that.$$.isValidObj(that.rightsToken)) {
        that.getRightsInfo();
      }else {
        that.$$.alert({
          message: '参数有误，请重新领取权益!',
          onOk: function () {
            that.$router.go(-1);
          }
        });
      }

      // 录制token
      let eventLogToken = decodeURIComponent(encodeURIComponent(that.$route.query.eventLogToken).replace(new RegExp("%20","gm"),"%2B"));
      if (that.$$.isValidObj(eventLogToken)) {
        that.screenRecBase.startLoad();
        that.eventLogToken = eventLogToken;
      }
    }
  }
</script>

<style scoped>
  /**
 * 穗岁康-填写参保信息 css
 * @Author 吴成林
 * @Date 2022-10-24 16:00
 */

  #sskInfoFillingPage {
    max-width: 750px;
    margin: 0 auto;
    position: relative;
    width: 100%;
    height: 100%;
    background: #ffffff;
    padding: 0 12px 60px;
  }

  /* 内容*/
  .headline{
    font-size: 16px;
    padding: 5px 0;
    border-bottom: 1px solid #F2F4F7;
    margin-bottom: 15px;
  }

  .punctuation{
    line-height: 18px;
    padding: 5px 0;
    border-bottom: 1px solid #F2F4F7;
  }

  .punctuation>span{
    display: inline-block;
    vertical-align: middle;
  }

  .punctuation>span:first-child{
    width: 3px;
    height: 16px;
    color: #ffffff;
    background: #75b2e8;
    text-align: center;
    margin-right: 2px;
  }

  .beInsureWrap li{
    height: 50px;
    min-height: 50px;
    margin: 0 10px;
    font-size: 14px;
    border-bottom: 1px solid #F2F4F7;
    position: relative;
  }

  .tit {
    width: 30%;
    height: 100%;
    letter-spacing: 1px;
    float: left;
    display: flex;
    align-items: center
  }

  .arrow:after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -5px;
    display: block;
    width: 10px;
    height: 10px;
    border-right: 2px solid #064f98;
    border-bottom: 2px solid #064f98;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  .sInfo {
    width: 69%;
    height: 100%;
    color: #CCCCCC;
    background: #ffffff;
    float: right;
    text-align: right;
    display: flex;
    align-items: center;
  }
  .sInfo div{
    width: 100%;
    font-size: 14px;
    color: #FA6E50;
  }

  input::-webkit-input-placeholder{
    color: #CCCCCC;
    font-weight: 400;
    font-size: 14px;
  }
  input{
    width: 100%;
    text-align: right;
    font-size: 14px;
    color: #FA6E50;
  }

  /* 底部 */
  footer{
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 101;
    background: #ffffff;
    width: 100%;
  }
  .footerUnit{
    max-width: 750px;
    margin: 0 auto;
    text-align: center;
    height: 5rem;
    display: flex;
  }
  .kefu{
    padding: 0 1.6rem;
    height: 100%;
    margin: 0 auto;
    text-align: center;
  }
  .kefuImg{
    width: 3rem;
    max-height: 3rem;
    padding-top: 100%;
    background: url("../../../../static/images/product/ssk/kefu.png") no-repeat center / cover;
  }
  .kefuText{
    text-align: center;
    font-size: 1.33rem;
    line-height: 2rem;
  }
  .submit{
    flex: 1;
    background: #064f98;
    color: #ffffff;
    font-size: 1.5rem;
    line-height: 5rem;
  }

  /* 身份核验通知弹窗 */
  .validationIdentityDialog /deep/ .el-dialog{
    margin: 10vh auto!important;
    border-radius: 4.267vw;
    position: relative;
    height: 80vh;
    max-width: 750px;
  }

  .validationIdentityDialog /deep/ .el-dialog__header,
  .validationIdentityDialog /deep/ .el-dialog__body{
    padding: 0;
  }

  .validationIdentityView{
    color: #666;
    position: relative;
  }

  .validationIdentityView .head{
    height: 11vh;
    position: relative;
  }
  .validationIdentityView .head>img{
    height: 100%;
  }
  .validationIdentityView .head .head-title{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 2rem;
    color: #074f98;
  }

  .validationIdentityView .check{
    height: 69vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .validationIdentityView .check::-webkit-scrollbar {
    display: none;
  }

  .validationIdentityView .check .validationContent{
    padding: 2.667vw 4vw 5rem;
    font-size: 1.4rem;
  }

  .validationIdentityView .check .validationContent>div{
    line-height: 2.6rem;
    text-indent: 2em;
  }

  .check-readPromise{
    height: 5rem;
    margin: 0 auto;
    justify-content: left;
    align-items: center;
  }
  .check-readPromise .whetherAgree{
    margin-right: 1rem;
  }
  .check-readPromise .whetherAgree>img{
    width: 1.5rem;
    height: 1.5rem;
  }
  .check-readPromise .readPromise{
    color: #074f98;
    border-bottom: 1px solid #074f98;
    line-height: 1.5rem;
    vertical-align: middle;
    text-indent: 0;
  }

  .validationIdentityView .dialogFooter{
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 5rem;
    line-height: 5rem;
    width: 100%;
    background: #FFFFFF;
    border-radius: 0 0 4.267vw 4.267vw;
    font-size: 1.5rem;
  }
  .validationIdentityView .dialogFooter>div{
    flex: 1;
  }
  .validationIdentityView .dialogFooter>div:last-child{
    color: #074f98;
  }

  /* 承诺书弹窗 */
  .readPromiseDialog /deep/ .el-dialog{
    margin: 0 auto!important;
    position: relative;
    height: 100vh;
    max-width: 750px;
  }

  .readPromiseDialog /deep/ .el-dialog__header,
  .readPromiseDialog /deep/ .el-dialog__body{
    padding: 0;
  }

  .readPromiseDialog .head{
    text-align: center;
    font-size: 2rem;
    padding: 2rem 0 3rem;
  }

  .readPromiseDialog .readPromiseContent{
    padding: 0 2rem 6rem;
    font-size: 1.5rem;
    color: #333333;
    background: #FFFFFF;
  }

  .readPromiseDialog .dialogFooter{
    position: fixed;
    bottom: 0;
    left: 0;
    height: 5rem;
    line-height: 5rem;
    width: 100%;
    color: #FFFFFF;
    font-size: 1.5rem;
  }
  .readPromiseDialog .dialogFooter>div{
    margin: 0 auto;
    text-align: center;
    max-width: 750px;
    background: #074f98;
  }

  /* 下拉列表 */
  html /deep/ .el-select-dropdown__item {
    padding-left: 5px!important;
  }

  .cardPopupState  {
    width: 100%;
    z-index: 2100!important;
  }

  .cardTypeList /deep/ .picker-toolbar{
    border-bottom: 1px solid #F2F4F7;
  }

  .cardTypeList .cancel{
    color: #999999;
    position: absolute;
    top: 10px;
    left: 20px;
    font-size: 1.5rem;
  }

  .cardTypeList .confirm{
    color: #074f98;
    position: absolute;
    top: 10px;
    right: 20px;
    font-size: 1.5rem;
  }

  /* 公共 */
  .flex {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
  a{
    display: inline;
    width: auto;
    text-decoration: none;
  }

  .none{
    display: none!important;
  }

  .dialogFooter>div,
  .submit,
  .dialogFooter,
  .readPromise,
  .whetherAgree{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/ssk/infoFillingPage.vue